<template>
  <div class="standing">
    <div class="operation-bar">
      <!-- search -->
      <search :role-data="allRoleList" @getUserList="getUserList"></search>
      <el-row class="operation-box">
        <el-button size="small" type="default" icon="el-hg-icon-detail" @click="getDetail">详情</el-button>
        <el-button size="small" type="default" icon="el-hg-icon-add" @click="add" v-permission="'0201'">新增</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="edit" v-permission="'0202'">修改</el-button>
        <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="delItems" v-permission="'0206'">删除</el-button>
        <el-button size="small" type="success" icon="el-hg-icon-start" @click="startUse" v-permission="'0204'">启用</el-button>
        <el-button size="small" type="warning" icon="el-hg-icon-stop" @click="stopUse" v-permission="'0205'">停用</el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh">刷新</el-button>
        <!--<el-button type="success" size="small"  @click="authority">权限</el-button>-->
      </el-row>
    </div>
    <!-- list view -->
    <list style="flex: 1;-webkit-box-flex: 1;overflow: hidden;max-height: 73%" :dataList.sync="aDataList" @detail="getDetail" />
    <div class="pagination-box">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <add :show="bAddShow" @close="bAddShow = false" :allRoleList="allRoleList" @refresh="refresh" />
    <edit-dialog :o-active-item-id="oActiveItemId" :title.sync="title" :is-edit.sync="isEdit" :show="bShowEditDialog" :allRoleList="allRoleList" @close="bShowEditDialog = false" @refresh="refresh" />
    <authority-dialog :authorityTree="authorityTree" :show="bShowAuthorityDialog" @close="bShowAuthorityDialog = false" @refresh="refresh" />
  </div>
</template>
<script>
import search from './search';
import list from './list';
import add from './actions/add';
import editDialog from './actions/edit';
import authorityDialog from './actions/authority';

export default {
  name: 'userManagement',
  components: {
    search,
    list,
    add,
    editDialog,
    authorityDialog
  },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        currentPage: 1
      },
      aDataList: [],
      total: 0,
      title: '用户编辑',
      isEdit: false,
      allRoleList: [],
      bAddShow: false,
      oActiveItemId: '',
      bShowEditDialog: false,
      bShowAuthorityDialog: false,
      authorityTree: []
    };
  },
  computed: {
    selected() {
      let ids = [];
      let userList = [];
      let textInfo = [];
      this.aDataList.forEach(data => {
        if (data.checked) {
          ids.push({
            value: data.id
          });
          textInfo.push(data.username);
          userList.push(data);
        }
      });
      return {
        ids,
        list: userList,
        textInfo
      };
    }
  },
  methods: {
    delItems() {
      this.deleteSystem();
    },
    async getAllRoleList() {
      const res = await this.$services.post({
        type: 'ROLEMANGEMENT',
        url: 'getAllRoleList'
      });
      if (res.code === '000') {
        this.allRoleList = res.bean;
      }
    },
    async deleteSystem() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(`此操作将永久删除用户<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>,  是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$services.postLoading({
          type: 'USERMANGEMENT',
          url: 'deleteUser',
          params: { delStatus: '1', ids: JSON.stringify(this.selected.ids) }
        }).then(res => {
          if (res.code === '000') {
            this.$toaster.ok('删除成功');
            this.refresh();
          }
          else {
            this.$toaster.error(res.msg);
          }
        });
      }).catch(() => {
      });
    },
    edit() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个用户');
        return;
      }
      this.title = '用户编辑';
      this.isEdit = true;
      this.oActiveItemId = this.selected.ids[0].value;
      this.bShowEditDialog = true;
    },
    getDetail() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个用户');
        return;
      }
      this.title = '用户详情';
      this.isEdit = false;
      this.oActiveItemId = this.selected.ids[0].value;
      this.bShowEditDialog = true;
    },
    add() {
      this.bAddShow = true;
    },
    async getUserList(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      const res = await this.$services.postLoading({
        type: 'USERMANGEMENT',
        url: 'getUserList',
        params: this.queryParams
      });
      res.bean.list.forEach(rep => {
        rep.checked = false;
      });
      this.aDataList = res.bean.list;
      this.total = res.bean.total;
    },
    handleCurrentChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.getUserList();
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize;
      this.getUserList();
    },
    refresh() {
      this.getUserList();
    },
    async updateStateByPrimaryKey(state) {
      // state 0：停用，1：启用
      const res = await this.$services.postLoading({
        type: 'USERMANGEMENT',
        url: 'updateStateByPrimaryKey',
        params: {
          ids: JSON.stringify(this.selected.ids),
          state
        }
      });
      if (res.code === '000') {
        this.$message({
          type: 'success',
          message: state === 0 ? '停用成功' : '启用成功'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: state === 0 ? '停用失败' : '启用失败'
        });
      }
    },
    startUse() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(`此操作将启用<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStateByPrimaryKey(1);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启用'
        });
      });
    },
    stopUse() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(`此操作将停用<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(',')} </span>, 是否继续?`, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStateByPrimaryKey(0);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停用'
        });
      });
    },
    async getAuthorityTree() { // 获取权限树
      const res = await this.$services.postLoading({
        type: 'ROLEMANGEMENT',
        url: 'getAuthorityTree'
      });
      this.authorityTree = res.bean;
    },
    authority() {
      this.bShowAuthorityDialog = true;
    }
  },
  created() {
    this.getUserList();
    this.getAllRoleList();
    this.getAuthorityTree();
  }
};
</script>
<style lang="scss" scoped>
.pagination-box {
  text-align: center;
}

.operation-box {
  margin: 10px 0;
}
</style>
